<template>
  <div class="number-info-content write-info-content">
    <div class="number-info-input">
      <span class="write-info-title">政府组织名称：</span>
      <a-input
        size="large"
        v-model="info.companyName"
        placeholder="请填写政府组织名称"
      />
    </div>
    <div class="number-info-input">
      <span class="write-info-title">统一社会信用代码：</span>
      <div>
        <div class="write-info-radio">
          <a-radio-group v-model="codeval">
            <a-radio :value="1">有独立代码</a-radio>
            <a-radio :value="2">无独立代码</a-radio>
          </a-radio-group>
        </div>
        <a-input
          v-if="codeval === 1"
          size="large"
          placeholder="请填写统一社会信用代码"
          v-model="info.code"
        />
        <div v-else class="write-info-no-code">
          <a-textarea
            v-model="info.socialCreditCodeExplain"
            placeholder="请说明无独立信用代码情况"
          />
        </div>
      </div>
    </div>
    <div class="number-info-input">
      <span class="write-info-title">组织联系人：</span>
      <a-input
        size="large"
        placeholder="请填写组织联系人姓名"
        v-model="info.contactPerson"
      />
    </div>
    <div class="number-info-input">
      <span class="write-info-title">联系电话：</span>
      <a-input
        size="large"
        placeholder="请输入联系电话"
        v-model="info.contactPhone"
      />
    </div>
  </div>
</template>

<script>
import { registerSupplementInfo2 } from "@/api/login";

export default {
  name: "GovInfo",
  data() {
    return {
      codeval: 1,
      info: {
        companyName: "",
        code: "",
        socialCreditCodeExplain: "",
        contactPerson: "",
        contactPhone: "",
      },
    };
  },
  methods: {
    submit() {
      const { info } = this;
      if (!info.companyName) {
        this.$message.warning("请填写政府组织名称");
        return;
      }
      if (this.codeval === 1) {
        if (!info.code) {
          this.$message.warning("请填写统一社会信用代码");
          return;
        }
      } else {
        if (!info.socialCreditCodeExplain) {
          this.$message.warning("请填写无社会信用代码说明");
          return;
        }
      }
      if (!info.contactPerson) {
        this.$message.warning("请填写组织联系人");
        return;
      }
      if (!info.contactPhone) {
        this.$message.warning("请填写联系电话");
        return;
      }
      let data = {
        companyName: info.companyName,
        englishName: "",
        socialCreditCode: info.code,
        industry: "",
        regAddress: "",
        userId: "",
        status: "",
        introduction: "",
        regCapitalUnit: "",
        validCertId: null,
        applyTime: null,
        auditReason: null,
        socialCreditCodeExplain: info.socialCreditCodeExplain,
        companyType: "1",
        contactPerson: info.contactPerson,
        contactPhone: info.contactPhone,
      };
      registerSupplementInfo2(data).then((res) => {
        this.$store.dispatch("GetInfo");
        this.$emit("success", res.data);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.number-info-content {
  height: 510px;
  padding-top: 40px;

  .number-info-input {
    display: flex;
    margin-bottom: 32px;
    justify-content: space-between;

    .write-info-title {
      width: 130px;
      text-align: right;
      line-height: 40px;
    }

    > div {
      flex: 1;

      .write-info-radio {
        height: 40px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .write-info-no-code {
        > textarea {
          height: 80px;
          margin-bottom: 16px;
        }

        .write-upload-list {
          margin-top: 16px;

          > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 32px;
            padding: 0 16px;
            background: #f5f5f5;

            > p {
              display: flex;
              align-items: center;
              max-width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              > img {
                margin-right: 16px;
              }
            }

            > span {
              color: #1abc9c;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .enterprise-info {
    padding-left: 34px;
    margin-bottom: 24px;

    > p {
      font-size: 14px;
      color: #8c8c8c;
      display: flex;
      align-items: center;
      line-height: 14px;
      margin-bottom: 16px;

      > i {
        color: #faad14;
        margin-right: 8px;
      }
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      border-top: 1px solid #f0f0f0;
      border-left: 1px solid #f0f0f0;

      > div {
        width: 50%;
        display: flex;

        > span {
          width: 120px;
          line-height: 32px;
          background: #ebf9f6;
          border-right: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
          padding-left: 10px;
          color: #8c8c8c;
          font-size: 12px;
        }

        > p {
          flex: 1;
          padding: 0 10px;
          border-right: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
          font-size: 12px;
          height: 32px;
          line-height: 32px;
        }

        &:last-child {
          > p {
            height: 72px;
            line-height: 22px;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
